import { ResumeDistributionVisual } from './ResumeDistributionVisual'
export default ResumeDistributionVisual
